import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CourtshipTypeEnum, CourtshipTypeLabels } from '../../../enums/courtship-type.enum';

@Component({
    selector: 'rms-courtship-modal',
    templateUrl: './courtship-modal.component.html',
    styleUrls: ['./courtship-modal.component.scss'],
    standalone: false
})
export class CourtshipModalComponent implements OnInit {

  @ViewChild('courtshipModal', { static: true }) private courtshipModalRef: ElementRef;

  @Input() currentCourtship: CourtshipTypeEnum;

  public selectedCourtship: CourtshipTypeEnum;
  public readonly courtshipList = Object.values(CourtshipTypeEnum).filter(v => typeof v !== 'function');
  protected readonly CourtshipTypeLabels = CourtshipTypeLabels;

  private modalRef: NgbModalRef;

  constructor(
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
  }

  public openModal() {
    this.modalRef = this.modalService.open(this.courtshipModalRef, {size: 'md'});
    return this.modalRef;
  }

  public submit() {
    if (this.selectedCourtship == null) {
      return;
    }

    this.modalRef.close(this.selectedCourtship);
  }
}
